import { Injectable } from '@angular/core';
import { Observable ,  Subject , BehaviorSubject} from 'rxjs';

@Injectable()
export class formService {
    private subject = new BehaviorSubject<any>(null);

    sendSupplyFormData(formData: any) {
        this.subject.next({ formDataVal: formData });
    }

    getSupplyFormData(): Observable<any> {
        return this.subject.asObservable();
    }
    
}